import { LoginType, LogoutType, ResetAdminDashboard, LoggedInUser, ResetMainDashboard, ResetSiteConfiguration, ResetManageUser } from '../actions/actionTypes';
import API from '../../services/requestService';
import ENDPOINT from '../../services/endpoints';
import { setItemToStorage, clearStorage, getItemFromStorage } from '../../services/utilService';
import { showToast, showLoader } from './common';
import { TOAST_HEADER, status, MESSAGES } from '../../services/constants';
import { Dispatch } from 'redux';
import { IModulesPermissions } from '../../shared/models/rolesPermissionModel';
import { IChangePassowrd, IResetPassword } from '../../shared/models/authModel';
import { get } from 'lodash';

export const login = (credential: any) => async (dispatch: Dispatch<any>) => {
    const data = `grant_type=password&scope=offline_access&username=${credential.username}&password=${encodeURIComponent(credential.password)}`;
    const headers = { "Content-Type": "application/x-www-form-urlencoded" };
    dispatch(showLoader(true));
    try {
        const { data: loginResponse }: any = await API.post(ENDPOINT.login, data, { headers });
        if (loginResponse) {
            setItemToStorage('auth', loginResponse);
            const userResponse: any = await dispatch(getLoggedInUser());
            setItemToStorage('user', userResponse);
            dispatch({ type: LoginType, isSuccess: true });
            dispatch(showLoader(false));
            return { isLoggedIn: true, userType: userResponse.userType };
        }
    } catch (e) {
    console.error('login ', e);
    dispatch(showLoader(false));
    dispatch(
        showToast(
            TOAST_HEADER.ERROR,
            (e as any)?.response?.data || (e as any)?.message || MESSAGES.common
        )
    );
    return e;
}
}

export const forgotPassword = (email: any) => (dispatch: any) => {
    dispatch(showLoader(true));
    return API.post(ENDPOINT.forgotPassword, { email })
        .then(res => {
            dispatch(showLoader(false));
            if (res.status === status.success) {
                dispatch(showToast(res.data.isSuccess ? TOAST_HEADER.SUCCESS : TOAST_HEADER.ERROR, res.data.message));
                return res.data.isSuccess
            }
            return false;
        })
        .catch(err => {
            setTimeout(() => {
                dispatch(showLoader(false));
            }, 3000);
            console.error(err)
            return false;
        })
}


export const resetPassword = (params: IResetPassword) => async (dispatch: any) => {
    dispatch(showLoader(true));
    try {
        const { data: response } = await API.post(ENDPOINT.resetPassword, params);
        dispatch(showLoader(false));
        dispatch(showToast(response.isSuccess ? TOAST_HEADER.SUCCESS : TOAST_HEADER.ERROR, response.message));
        return response.isSuccess;
    } catch (e) {
        console.error('resetPassword', e);
        dispatch(showLoader(false));
        dispatch(showToast(TOAST_HEADER.ERROR, MESSAGES.common));
        return e;
    }
}

export const checkIsLoggedIn = () => async (dispatch: any) => {
    dispatch(showLoader(true));
    const authRes = getItemFromStorage('auth');
    dispatch(showLoader(false));

    if (authRes && authRes.access_token) {
        const userResponse = await dispatch(getLoggedInUser());
        setItemToStorage('user', userResponse);
        return dispatch({ type: LoginType, isSuccess: true })
    } else {
        return dispatch(logout());
    }
}

export const changePassword = (params: IChangePassowrd) => async (dispatch: any) => {
    dispatch(showLoader(true));
    try {
        const { data: response } = await API.post(ENDPOINT.changePassword, params)
        dispatch(showLoader(false));
        dispatch(showToast(response.isSuccess ? TOAST_HEADER.SUCCESS : TOAST_HEADER.ERROR, response.message));
        if (response.isSuccess) {
            dispatch(logout());
        }
        return response.isSuccess;
    } catch (e) {
        console.error('changePassword', e);
        dispatch(showLoader(false));
        dispatch(showToast(TOAST_HEADER.ERROR, MESSAGES.common));
        return e;
    }
}

export const getLoggedInUser = () => async (dispatch: Dispatch<any>) => {
    try {
        const { data: userResponse }: any = await API.get(ENDPOINT.getUserDetail);
        if (userResponse && userResponse.isSuccess) {
            await dispatch({
                type: LoggedInUser,
                payload: { ...userResponse.data }
            })
        } else {
            dispatch(showToast(TOAST_HEADER.ERROR, userResponse.error));
        }
        return userResponse.data;
    } catch (e) {
        console.error('getLoggedInUser', e);
        if (get(e, 'response.status') === 401) {
            dispatch(logout());
        }
        dispatch(showToast(TOAST_HEADER.ERROR, MESSAGES.common));
        return e;
    }
}

export const logout = () => (dispatch: any) => {
    clearStorage();

    // reset adminReducer
    dispatch({ type: ResetAdminDashboard });
    dispatch({ type: ResetMainDashboard });
    dispatch({ type: ResetSiteConfiguration });
    dispatch({ type: ResetManageUser });

    // logout
    dispatch({ type: LogoutType, isSuccess: false });

}

